var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2794 38.9065H78.7204V77.2459H46.2794V38.9065Z",
    fill: "#F9EAB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7541 40.3811H77.2459L105.263 19.7368H19.7368L47.7541 40.3811Z",
    fill: "#ECF0F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7368 19.7368L47.7541 40.3811V75.7713L19.7368 105.263V19.7368Z",
    fill: "#F5EFCA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.263 19.7368L77.2458 40.3811V75.7713L105.263 105.263V19.7368Z",
    fill: "#F5EFCA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7368 105.263H105.263L77.2459 75.7712H47.7541L19.7368 105.263Z",
    fill: "#CB8252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8737 105.263L50.286 81.6697H74.7141L97.1264 105.263H27.8737Z",
    fill: "#A56A43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.873 50.7032V75.7713H55.1271V50.7032C55.1271 49.8888 55.7873 49.2286 56.6017 49.2286H68.3984C69.2128 49.2286 69.873 49.8888 69.873 50.7032Z",
    fill: "#A56A43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.873 62.5V65.4492H66.9238C66.1094 65.4492 65.4492 64.789 65.4492 63.9746C65.4492 63.1602 66.1094 62.5 66.9238 62.5H69.873Z",
    fill: "#BDC3C7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9064 48.7567V85.0907L24.1605 100.603L24.1605 44.038C24.16 43.5489 24.4022 43.0913 24.8069 42.8166C25.2116 42.5418 25.7263 42.4857 26.1807 42.6667L37.9774 47.3854C38.5389 47.6089 38.907 48.1524 38.9064 48.7567Z",
    fill: "#A56A43"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M100.839 44.038V100.603L86.0934 85.0907V48.7567C86.0928 48.1524 86.461 47.6089 87.0224 47.3854L98.8191 42.6667C99.2736 42.4857 99.7882 42.5418 100.193 42.8166C100.598 43.0913 100.84 43.5489 100.839 44.038Z",
    fill: "#A56A43"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9065 65.287V68.5753L36.6209 69.7108C36.4168 69.8197 36.1886 69.8755 35.9573 69.873C35.4002 69.8779 34.8897 69.5625 34.6449 69.0619C34.4672 68.7142 34.4357 68.3098 34.5576 67.9388C34.6794 67.5677 34.9444 67.2607 35.2937 67.086L38.9065 65.287Z",
    fill: "#BDC3C7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.839 69.7108V72.9991L97.2266 71.1854C96.7163 70.9729 96.3677 70.4929 96.3236 69.9419C96.2794 69.3909 96.5471 68.8615 97.017 68.5705C97.4869 68.2794 98.0801 68.2756 98.5537 68.5606L100.839 69.7108Z",
    fill: "#BDC3C7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4999 28.5844C65.7575 28.5844 68.3983 26.6038 68.3983 24.1606C68.3983 21.7174 65.7575 19.7368 62.4999 19.7368C59.2424 19.7368 56.6016 21.7174 56.6016 24.1606C56.6016 26.6038 59.2424 28.5844 62.4999 28.5844Z",
    fill: "#F0C419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMa);
export default __webpack_public_path__ + "static/media/ma.0944acee9828a21cadf2050cf1c73114.svg";
export { ForwardRef as ReactComponent };